import { Injectable } from '@angular/core';
import { CanLoad, Route, Router } from '@angular/router';
import { PermissionName } from '@tripointe/tripointe-cms/types';
import { PermissionsService } from './permissions.service';

@Injectable({ providedIn: 'root' })
export class PermissionsGuard implements CanLoad {
  constructor(private router: Router, private permissionsService: PermissionsService) {}

  canLoad(route: Route): any {
    if (this.permissionsService.hasPermissionTo(route.path as PermissionName)) {
      return true;
    } else {
      return this.router.parseUrl('');
    }
  }
}
